<style scoped>
  .menu div {  display: inline-block;  }
</style>
<template>
  <div class="animated fadeIn" :style="[estilo]">
    <div class="columns">
      <div class="column" v-if="temSlotTitulo">
        <slot name="titulo"/>
      </div>
      <div class="column has-text-right menu is-3" v-if="temSlotMenu">
        <slot name="menu"/>
      </div>
    </div>

    <slot/>
  </div>
</template>

<script>
  export default {
    props: {
      background: {
        type: String,
        default: '#ffffff'
      },
      border: {
        type: String,
        default: '#c2c5c7'
      },
      padding: {
        type: String,
        default: '13px'
      },
      nivel: {
        type: Number,
        default: 1
      }
    },
    data () {
      return {
        estilo: {
          backgroundColor: this.background,
          border: this.border,
          padding: this.padding,
          '-webkit-box-shadow': '1px 1px ' + (this.nivel * 5) + 'px 0px rgba(150,150,150,0.4)',
          '-moz-box-shadow': '1px 1px ' + (this.nivel * 5) + 'px 0px rgba(150,150,150,0.4)',
          'box-shadow': '1px 1px ' + (this.nivel * 5) + 'px 0px rgba(150,150,150,0.4)'
        }
      }
    },
    computed: {
      temSlot () {
        return !!this.$slots.default
      },
      temSlotMenu () {
        return !!this.$slots['menu']
      },
      temSlotTitulo () {
        return !!this.$slots['titulo']
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PortalBox.vue